import { render, staticRenderFns } from "./myDocMore.vue?vue&type=template&id=2766ce94&scoped=true"
import script from "./myDocMore.vue?vue&type=script&lang=js"
export * from "./myDocMore.vue?vue&type=script&lang=js"
import style0 from "./myDocMore.vue?vue&type=style&index=0&id=2766ce94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766ce94",
  null
  
)

export default component.exports